<app-modal [modalConfig]="modalConfig">
    <div class="section-container" *ngIf="!isLoading">
        <div class="header-section">
            <button class="filter-button" (click)="toggleFilters()" [ngClass]="{'active':enableFilters}">
                <fa-icon [icon]="faFilter" class="filter-icon"></fa-icon>
                <span>Filtrar Búsqueda</span>
            </button>
        </div>
        <section class="section-content">
            <div class="table-container">
                <app-table [headers]="headers" tableLabel="Report list Table" [enableFilters]="enableFilters"
                    (searchEvent)="search$.next($event)" (sortEvent)="search$.next($event)">
                    <tr tableBody *ngFor="let report of reports">
                        <td class="break-word">{{ report.nombre }}</td>
                        <td>{{ report.tipoReporte }}</td>
                        <td class="expanded-col">
                            {{report.descripcion}}
                        </td>
                        <td>{{ report.origen }}</td>
                    </tr>
                </app-table>
                <div *ngIf="reports.length === 0" class="empty-list">
                    ¡No se encontraron datos!
                </div>
            </div>
            <app-paginator *ngIf="reports.length > 0" [actualPage]="pageable.currentPage"
                [quantity]="pageable.itemsQuantity" [maxQuantity]="pageable.totalElements" [maxSize]="7"
                (changePageEvent)="changePage($event)">
            </app-paginator>
        </section>
    </div>
    <div class="loader" *ngIf="isLoading">
        <ngx-ui-loader loaderId="report-list" [hasProgressBar]="false"></ngx-ui-loader>
    </div>

</app-modal>